// extracted by mini-css-extract-plugin
module.exports = {"feedbackify":"feedbackify_feedbackify__1M2y2","active":"feedbackify_active__pFk77"};